import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DeliveryScanner } from "@/components/DeliveryScanner";

export const DeliveryLookup = ({ onFound }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const lookup = async (qrValue = "") => {
    setBusy(true); setError("");
    const proof = { code: qrValue ? "" : code, qr_value: qrValue };
    try { const { data } = await api.post("/deliveries/lookup", proof); onFound(data, proof); }
    catch (e) { setError(e.response?.data?.detail || "Não foi possível identificar a encomenda"); }
    finally { setBusy(false); }
  };
  return <div className="rounded-xl border border-border bg-card p-4 mb-5 space-y-3" data-testid="delivery-lookup">
    <p className="text-sm font-semibold">1. Identificar a encomenda</p>
    <DeliveryScanner onRead={(value) => lookup(value)} />
    <div><Label htmlFor="lookup-code">Ou introduzir os 6 dígitos</Label><div className="flex gap-2 mt-1"><Input id="lookup-code" inputMode="numeric" autoComplete="off" placeholder="123456" maxLength={7} data-testid="lookup-delivery-code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} /><Button disabled={busy || !code.trim()} data-testid="lookup-delivery-btn" onClick={() => lookup()}>{busy ? "A verificar…" : "Verificar"}</Button></div></div>
    <p className="text-xs text-muted-foreground">A consulta não cobra nada. Códigos antigos com prefixo continuam válidos.</p>
    {error && <p className="text-sm text-destructive" role="alert" data-testid="delivery-lookup-error">{error}</p>}
  </div>;
};
